import React, { useState } from "react";
import { useGetGiftcardBrandsQuery } from "../../../features/giftcards/giftcardsSlice";

interface BrandListProps {
  countryCode: string;
  onSelect: (brandId: number, brandName: string) => void;
}

export const BrandList: React.FC<BrandListProps> = ({ countryCode, onSelect }) => {
  const { data: brands, isLoading, error } = useGetGiftcardBrandsQuery(countryCode);
  const [search, setSearch] = useState("");

  const filteredBrands = brands?.filter((brand) =>
    brand.brandName.toLowerCase().includes(search.toLowerCase())
  );

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="h-24 bg-gray-800 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-500 text-center py-4">
        Failed to load brands. Please try again.
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search brands..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-primary"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {filteredBrands?.map((brand) => (
          <button
            key={brand.brandId}
            onClick={() => onSelect(brand.brandId, brand.brandName)}
            className="flex flex-col items-center p-4 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors"
          >
            <img
              src={brand.logoUrl}
              alt={brand.brandName}
              className="w-16 h-16 object-contain mb-2"
              onError={(e) => {
                (e.target as HTMLImageElement).src = "https://via.placeholder.com/64";
              }}
            />
            <span className="text-white text-sm text-center truncate w-full">
              {brand.brandName}
            </span>
            <span className="text-gray-400 text-xs mt-1">
              {brand.productCount} products
            </span>
          </button>
        ))}
      </div>

      {filteredBrands?.length === 0 && (
        <div className="text-gray-400 text-center py-8">
          No brands found matching "{search}"
        </div>
      )}
    </div>
  );
};
